import { OrderDetail } from '@/services/types/payment'
import SJCard from '@/components/SJCard'
import { useEffect, useState } from 'react'
import { orderDetail } from '@/services/payment'
import icons from '@/assets/icons'
import dayjs from 'dayjs'
import './index.less'

const OrderInfo = ({ orderCode }: { orderCode: string }) => {
  const [order, setOrder] = useState<OrderDetail>()
  const fetchOrder = async () => {
    try {
      const res = (await orderDetail(orderCode)) as unknown as OrderDetail
      setOrder(res)
    } catch (error) {}
  }
  useEffect(() => {
    orderCode && fetchOrder()
  }, [orderCode])

  return (
    <SJCard className="section-item">
      {order ? (
        <>
          <InfoItem title="订单编号：" detail={OrderCode(order.orderCode)}></InfoItem>
          {order.orderTime && (
            <InfoItem
              title="下单时间："
              detail={dayjs(Number(order.orderTime)).format('YYYY-MM-DD HH:mm:ss')}
            ></InfoItem>
          )}
          {order.tradeTime && (
            <InfoItem
              title="支付时间："
              detail={dayjs(Number(order.tradeTime)).format('YYYY-MM-DD HH:mm:ss')}
            ></InfoItem>
          )}
        </>
      ) : undefined}
    </SJCard>
  )
}

type InfoItemProps = {
  title: string
  detail?: any
  indicator?: boolean
  onClick?: () => void
}
const InfoItem = ({ title, detail, onClick, ...rest }: InfoItemProps) => {
  return (
    <div className="info-item" {...rest}>
      <span className="label">{title}</span>
      {typeof detail === 'string' ? <span className="value">{detail}</span> : detail}
    </div>
  )
}
const OrderCode = (code: string) => {
  const handleCopy = () => {
    // Taro.setClipboardData({
    //   data: code,
    //   success() {
    //     Taro.getClipboardData({
    //       success(res) {
    //         console.log(res.data) // data
    //       },
    //     })
    //   },
    // })
  }
  return (
    <>
      <span className="value">{code}</span>
      <img src={icons.IconCopy} className="copy" onClick={handleCopy} alt="" />
    </>
  )
}

export default OrderInfo
